import { render, staticRenderFns } from "./TeacherMainButton.vue?vue&type=template&id=23f27812&scoped=true"
import script from "./TeacherMainButton.vue?vue&type=script&lang=ts"
export * from "./TeacherMainButton.vue?vue&type=script&lang=ts"
import style0 from "./TeacherMainButton.vue?vue&type=style&index=0&id=23f27812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f27812",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
